import { safeLocalStorage } from './safeLocalStorage';

type EtagFetchOptions = {
  url: string;
  etagStorageKey?: string;
  valueStorageKey?: string;
};

export const etagFetch = async <T>(options: EtagFetchOptions) => {
  const { url, etagStorageKey = 'stored-etag', valueStorageKey = 'stored-value' } = options;

  try {
    const headers: HeadersInit = {};

    const storedEtag = safeLocalStorage.getItem(etagStorageKey);

    if (storedEtag) {
      headers['If-None-Match'] = storedEtag;
    }

    const response = await fetch(url, { headers });

    if (response.status === 304) {
      const cachedValue = safeLocalStorage.getItem(valueStorageKey);
      const data = cachedValue ? JSON.parse(atob(cachedValue)) : undefined;
      return data as T | undefined;
    }

    const etag = response.headers.get('ETag');
    const data = (await response.json()) as T | undefined;

    if (etag && etag !== storedEtag) {
      safeLocalStorage.setItem(etagStorageKey, etag);
      safeLocalStorage.setItem(valueStorageKey, btoa(JSON.stringify(data)));
    }

    return data;
  } catch (error) {
    return undefined as T | undefined;
  }
};
